export default {
  GET_OPERATOR_WRITING_INFO: 'operator_writing_info',
  OPERATOR_START_WRITING: 'operator_started_writing',
  OPERATOR_FINISHED_WRITING: 'operator_finished_writing'
}
